var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuAlt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 5.6C2.3999 5.38783 2.48419 5.18435 2.63422 5.03432C2.78425 4.88429 2.98773 4.8 3.1999 4.8H12.7999C13.0121 4.8 13.2156 4.88429 13.3656 5.03432C13.5156 5.18435 13.5999 5.38783 13.5999 5.6C13.5999 5.81218 13.5156 6.01566 13.3656 6.16569C13.2156 6.31572 13.0121 6.4 12.7999 6.4H3.1999C2.98773 6.4 2.78425 6.31572 2.63422 6.16569C2.48419 6.01566 2.3999 5.81218 2.3999 5.6ZM2.3999 10.4C2.3999 10.1878 2.48419 9.98435 2.63422 9.83432C2.78425 9.68429 2.98773 9.6 3.1999 9.6H12.7999C13.0121 9.6 13.2156 9.68429 13.3656 9.83432C13.5156 9.98435 13.5999 10.1878 13.5999 10.4C13.5999 10.6122 13.5156 10.8157 13.3656 10.9657C13.2156 11.1157 13.0121 11.2 12.7999 11.2H3.1999C2.98773 11.2 2.78425 11.1157 2.63422 10.9657C2.48419 10.8157 2.3999 10.6122 2.3999 10.4Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAlt4);
export default __webpack_public_path__ + "static/media/MenuAlt4.c9669a5a256f99252e4ca886ad50fd49.svg";
export { ForwardRef as ReactComponent };